import React, {useEffect, useState} from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import BottomToTop from '../../../../components/transitions/bottom-to-top'
import {Iconfont} from "../../../../components/icon/iconfont";
import useStyles from 'isomorphic-style-loader/useStyles'
import { FormattedMessage } from 'react-intl';

const FilterItem = props => {
	useStyles(classes)
	const { filterItem, value, onChange } = props

	const handleClick = (s, fieldName) => {
		const existSelection = value?.selections?.some(selection => selection.value === s.value)
		let newValue
		if(existSelection){
			newValue = {
				...value,
				fieldName,
				selections: value?.selections?.filter(selection => selection.value !== s.value)
			}
		}else{
			newValue = {
				...value,
				fieldName,
				selections: [...(value?.selections||[]), s]
			}
		}
		onChange(newValue)
	}

	const isActive = s => {
		return value?.selections?.some?.(selection => selection.value === s.value)
	}

	return <div className={classes.FilterItem}>
		<div className={classes.Hd}>
			{filterItem.title}
		</div>
		<div className={classes.Bd}>
			{
				filterItem?.selections?.map(selection => <span onClick={() =>{handleClick(selection, filterItem.fieldName)}} className={`${classes.Selection} ${isActive(selection)?classes.Active:''}`} key={selection.value}>{selection.label}</span>)
			}
		</div>
	</div>
}

const FilterPanel = props => {
	const {filterVo, value, onChange} = props
	const getExactValue = fn => {
		return value?.find(v => v.fieldName ===fn)
	}

	const changeHandle = exactValue => {
		const exist = value?.some(v => v.fieldName === exactValue.fieldName)
		let newValue
		if(exist){
			newValue = value?.map(v => {
				if(v.fieldName === exactValue.fieldName){
					return exactValue
				}
				return v
			})
		}else{
			newValue = [...(value||[]), exactValue]
		}

		onChange(newValue)

	}

	return <div className={classes.FilterItems}>
		{
			filterVo?.filterItems?.filter(f => f.fieldName !== 'tags')?.map(filterItem => <FilterItem onChange={changeHandle} value={getExactValue(filterItem.fieldName)} key={filterItem.fieldName} filterItem={filterItem}/>)
		}
	</div>
}

const PageFilter = props => {

	const {filterVo, value} = props

	const [filterValue, setFilterValue] = useState(value)

	useEffect(() => {
		setFilterValue(value)
	}, [
		JSON.stringify(value)
	])


	const changeHandle = v => {
		setFilterValue(v)
	}

	const handleSubmit = () => {
		props?.onSubmit(filterValue)
	}

	const handleClear = () => {
		props?.onClear()
	}



	return <BottomToTop in={props.showFilter} className={classes.FilterPageContainer}>
		<div>
			<div className={classes.FilterPage}>
				<div className={classes.Hd}>
					<Iconfont className={classes.Close} onClick={() => { props?.onClose()} }>&#xe69a;</Iconfont>
					<span><FormattedMessage id="filter" defaultMessage="Filter"/></span>
				</div>
				<div className={classes.Bd}>
					<FilterPanel filterVo={filterVo} value={filterValue} onChange={changeHandle}/>
				</div>
				<div className={classes.Fd}>
					<button onClick={() => {setFilterValue([])}} className={classes.OpBtn}><FormattedMessage id="clear" defaultMessage="Clear"/></button>
					<button onClick={() => {handleSubmit()}} className={`${classes.OpBtn} ${classes.Active}`}><FormattedMessage id="apply" defaultMessage="Apply"/></button>
				</div>
			</div>
		</div>
	</BottomToTop>
}


const MemoFilter = React.memo(PageFilter, (prevProps, nextProps) => {
	return JSON.stringify(prevProps) === JSON.stringify(nextProps)
});


export default props => {

	if (typeof window === 'undefined') {
		return null;
	}

	return ReactDOM.createPortal(
		<MemoFilter {...props}/>,
		document.getElementById('root')
	)
}
